// Configuración del molde del formulario
export const FORM_TEMPLATE = {
    generales: {
        title: "Información General",
        icon: "pi pi-info-circle",
        fields: {
            electricidad_fase: { type: "dropdown", label: "Fase eléctrica", options: [{label: "Monofásico", value: "monofasico"}, {label: "Trifásico", value: "trifasico"}] },
            electricidad_amperaje: { type: "number", label: "Amperaje (A)", placeholder: "ej: 25" },
            ventilacion: { type: "dropdown", label: "Ventilación", options: [{label: "Natural", value: "natural"}, {label: "Forzada", value: "forzada"}, {label: "Mecánica", value: "mecanica"}] }
        }
    },
    caracteristicas: {
        title: "Características Físicas",
        icon: "pi pi-building",
        fields: {
            altura_m_hombro: { type: "number", label: "Altura al hombro (m)", placeholder: "ej: 4.5" },
            altura_maxima_m: { type: "number", label: "Altura máxima (m)", placeholder: "ej: 6" },
            piso: { type: "text", label: "Tipo de piso", placeholder: "ej: Hormigón H25 15 cm" },
            capacidad_carga_kg: { type: "number", label: "Capacidad de carga (kg)", placeholder: "ej: 5000" }
        }
    },
    servicios: {
        title: "Servicios e Instalaciones",
        icon: "pi pi-cog",
        fields: {
            baño: { type: "checkbox", label: "Baño" },
            oficina: { type: "checkbox", label: "Oficina" },
            estanterias: { type: "checkbox", label: "Estanterías incluidas" },
            montacargas: { type: "checkbox", label: "Montacargas disponible" }
        }
    },
    accesos: {
        title: "Accesos y Seguridad",
        icon: "pi pi-shield",
        fields: {
            acceso_camiones: { type: "checkbox", label: "Acceso para camiones" },
            rampa: { type: "checkbox", label: "Rampa de acceso" },
            camaras: { type: "checkbox", label: "Cámaras de seguridad" },
            cerco: { type: "checkbox", label: "Cerco perimetral" },
            guardiania: { type: "checkbox", label: "Guardianía" },
            alarma: { type: "checkbox", label: "Sistema de alarma" }
        },
    },
    observaciones: {
        title: "Observaciones",
        icon: "pi pi-comment",
        fields: {
            observaciones: { type: "textarea", label: "Observaciones generales", placeholder: "Información adicional..." }
        }
    }
};

// Moldes específicos por perfil
export const PROFILE_TEMPLATES = {
    modulos: {
        modulos: {
            title: "Módulos",
            icon: "pi pi-th-large",
            fields: {
                titulo_modulo: { type: "text", label: "Título: Módulo [Nombre/Referencia] – [Proveedor]" },
                uso_aplicacion: { type: "dropdown", label: "Uso/Aplicación", options: [
                    { label: "Construcción", value: "construccion" },
                    { label: "Eléctrico", value: "electrico" },
                    { label: "Almacenamiento", value: "almacenamiento" },
                ]},
                dimensiones: { type: "text", label: "Dimensiones: [L x A x H]" },
                ubicacion: { type: "text", label: "Ubicación: [Dirección]" },
                peso_kg: { type: "number", label: "Peso: [kg]", placeholder: "ej: 1200" },
                area_total_m2: { type: "number", label: "Área total: [m²]", placeholder: "ej: 24" },
                materiales: { type: "dropdown", label: "Materiales", options: [
                    { label: "Acero", value: "acero" },
                    { label: "Aluminio", value: "aluminio" },
                    { label: "Madera", value: "madera" },
                ]},
                estructura: { type: "dropdown", label: "Estructura", options: [
                    { label: "Acero", value: "acero" },
                    { label: "Concreto", value: "concreto" },
                    { label: "Gypsum", value: "gypsum" },
                ]},
                revestimientos: { type: "dropdown", label: "Revestimientos", options: [
                    { label: "Pintura", value: "pintura" },
                    { label: "Pisos cerámicos", value: "pisos_ceramicos" },
                    { label: "Alfombra", value: "alfombra" },
                ]},
                montaje: { type: "dropdown", label: "Montaje", options: [
                    { label: "Tornillos", value: "tornillos" },
                    { label: "Ganchos", value: "ganchos" },
                ]},
                ventilacion: { type: "dropdown", label: "Ventilación", options: [
                    { label: "Natural", value: "natural" },
                    { label: "Forzada", value: "forzada" },
                ]},
                iluminacion: { type: "dropdown", label: "Iluminación", options: [
                    { label: "LED", value: "led" },
                    { label: "Natural", value: "natural" },
                    { label: "Regulable", value: "regulable" },
                ]},
                aislamiento: { type: "dropdown", label: "Aislamiento", options: [
                    { label: "Térmico", value: "termico" },
                    { label: "Acústico", value: "acustico" },
                ]},
                climatizacion: { type: "dropdown", label: "Climatización", options: [
                    { label: "A/C", value: "ac" },
                    { label: "Natural", value: "natural" },
                ]},
                normativas: { type: "dropdown", label: "Normativas", options: [
                    { label: "ISO", value: "iso" },
                    { label: "ASTM", value: "astm" },
                ]},
                sistema_electrico: { type: "text", label: "Sistema eléctrico: [Voltaje / Tomas / UPS]" },
                disponibilidad: { type: "dropdown", label: "Disponibilidad", options: [
                    { label: "Inmediata", value: "inmediata" },
                    { label: "Stock", value: "stock" },
                    { label: "Plazo de entrega", value: "plazo_entrega" },
                ]},
                accesorios: { type: "text", label: "Accesorios: Papel higiénico, bidón agua, kit limpieza" },
            }
        }
    },
    bano: {
        bano: {
            title: "Baño",
            icon: "pi pi-home",
            fields: {
                titulo_banio: { type: "text", label: "Título: Baño Químico [Modelo] – [Proveedor]" },
                dimensiones_banio: { type: "text", label: "Dimensiones: [L x A x H]" },
                peso_banio_kg: { type: "number", label: "Peso: [kg]", placeholder: "ej: 150" },
                tanque_agua_limpia_l: { type: "number", label: "Tanque agua limpia: [litros]", placeholder: "ej: 200" },
                materiales_banio: { type: "text", label: "Materiales: Polietileno (HDPE) resistente" },
                tanque_residuos_l: { type: "number", label: "Tanque residuos: [litros]", placeholder: "ej: 180" },
                sistema_descarga: { type: "dropdown", label: "Sistema de descarga", options: [
                    { label: "Química", value: "quimica" },
                    { label: "Manual", value: "manual" },
                ]},
                ventilacion_banio: { type: "dropdown", label: "Ventilación", options: [
                    { label: "Natural", value: "natural" },
                    { label: "Forzada", value: "forzada" },
                ]},
                iluminacion_banio: { type: "dropdown", label: "Iluminación", options: [
                    { label: "LED", value: "led" },
                    { label: "Natural", value: "natural" },
                    { label: "Regulable", value: "regulable" },
                ]},
                usuarios_por_ciclo: { type: "number", label: "Usuarios por ciclo: [Capacidad máx.]", placeholder: "ej: 20" },
                normativas_sanitarias: { type: "text", label: "Normativas: Sanitarias/ambientales locales e internacionales" },
                disponibilidad_banio: { type: "dropdown", label: "Disponibilidad", options: [
                    { label: "Inmediata", value: "inmediata" },
                    { label: "Plazo de entrega", value: "plazo_entrega" },
                ]},
                accesorios_banio: { type: "text", label: "Accesorios: Papel higiénico, bidón agua, kit limpieza" },
            }
        }
    },
    oficina: {
        oficina: {
            title: "Oficina",
            icon: "pi pi-building",
            fields: {
                titulo_oficina: { type: "text", label: "Título: Oficina [Referencia] – [Proyecto]" },
                uso_aplicacion_oficina: { type: "dropdown", label: "Uso/Aplicación", options: [
                    { label: "Construcción", value: "construccion" },
                    { label: "Eléctrico", value: "electrico" },
                    { label: "Almacenamiento", value: "almacenamiento" },
                ]},
                dimensiones_oficina: { type: "text", label: "Dimensiones: [L x A x H]" },
                ubicacion_oficina: { type: "text", label: "Ubicación: [Dirección]" },
                peso_oficina_kg: { type: "number", label: "Peso: [kg]", placeholder: "ej: 1000" },
                area_total_oficina_m2: { type: "number", label: "Área total: [m²]", placeholder: "ej: 18" },
                ambientes: { type: "dropdown", label: "Ambientes", options: [
                    { label: "Individuales", value: "individuales" },
                    { label: "Open space", value: "open_space" },
                    { label: "Comunes", value: "comunes" },
                ]},
                capacidad: { type: "number", label: "Capacidad: [Carga o volumen]", placeholder: "ej: 10" },
                materiales_oficina: { type: "dropdown", label: "Materiales", options: [
                    { label: "Acero", value: "acero" },
                    { label: "Aluminio", value: "aluminio" },
                    { label: "Madera", value: "madera" },
                ]},
                estructura_oficina: { type: "dropdown", label: "Estructura", options: [
                    { label: "Prefabricado", value: "prefabricado" },
                    { label: "Desmontable", value: "desmontable" },
                ]},
                revestimientos_oficina: { type: "dropdown", label: "Revestimientos", options: [
                    { label: "Pintura", value: "pintura" },
                    { label: "Pisos cerámicos", value: "pisos_ceramicos" },
                    { label: "Alfombra", value: "alfombra" },
                ]},
                montaje_oficina: { type: "dropdown", label: "Montaje", options: [
                    { label: "Tornillos", value: "tornillos" },
                    { label: "Ganchos", value: "ganchos" },
                ]},
                ventilacion_oficina: { type: "dropdown", label: "Ventilación", options: [
                    { label: "Natural", value: "natural" },
                    { label: "Forzada", value: "forzada" },
                ]},
                iluminacion_oficina: { type: "dropdown", label: "Iluminación", options: [
                    { label: "LED", value: "led" },
                    { label: "Natural", value: "natural" },
                    { label: "Regulable", value: "regulable" },
                ]},
                aislamiento_oficina: { type: "dropdown", label: "Aislamiento", options: [
                    { label: "Térmico", value: "termico" },
                    { label: "Acústico", value: "acustico" },
                ]},
                climatizacion_oficina: { type: "dropdown", label: "Climatización", options: [
                    { label: "A/C", value: "ac" },
                    { label: "Natural", value: "natural" },
                ]},
                normativas_oficina: { type: "dropdown", label: "Normativas", options: [
                    { label: "ISO", value: "iso" },
                    { label: "ASTM", value: "astm" },
                ]},
                sistema_electrico_oficina: { type: "text", label: "Sistema eléctrico: [Voltaje / Tomas / UPS]" },
                mobiliario: { type: "text", label: "Mobiliario: Escritorios, sillas, estanterías" },
                seguridad: { type: "text", label: "Seguridad: Extinción incendios, CCTV, control acceso" },
                disponibilidad_oficina: { type: "dropdown", label: "Disponibilidad", options: [
                    { label: "Inmediata", value: "inmediata" },
                    { label: "Plazo de entrega", value: "plazo_entrega" },
                ]},
            }
        }
    }
};

export const PERFIL_OPTS = [
    { value: "estandar", label: "Estándar" },
    { value: "modulos", label: "Módulos" },
    { value: "bano", label: "Baño" },
    { value: "oficina", label: "Oficina" },
];

// Helpers compartidos (src/utilities/fichaTemplateHelpers.js)
export { toSnakeCase, getDefaultValue, generateInitialState } from "../../../utilities/fichaTemplateHelpers.js";
